/**
 * Slug Generation Utilities
 *
 * Helper functions for generating URL-friendly slugs from blog post titles.
 * Uses the slugify library with strict mode for clean URLs.
 */

import slugify from 'slugify';

/**
 * Generate a URL-friendly slug from a title
 * @param title - The blog post title
 * @returns Lowercase slug with hyphens instead of spaces
 *
 * @example
 * generateSlug('How to Fix Cracked Mortar Joints')
 * // Returns: 'how-to-fix-cracked-mortar-joints'
 */
export const generateSlug = (title: string): string => {
  return slugify(title, {
    lower: true,
    strict: true, // Remove special characters
  });
};

/**
 * Validate that a slug is URL-safe
 * @param slug - The slug to validate
 * @returns True if the slug is valid
 */
export const isValidSlug = (slug: string): boolean => {
  // Only allow lowercase letters, numbers, and hyphens
  return /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(slug);
};
